/**
 * Seeded and unseeded random helpers for procedural generation (Phase 3+).
 */
export class Random {
  /** @param {number} [seed] */
  constructor(seed = Date.now()) {
    this._seed = seed >>> 0;
  }

  /** @returns {number} [0, 1) */
  next() {
    this._seed = (1664525 * this._seed + 1013904223) >>> 0;
    return this._seed / 4294967296;
  }

  range(min, max) {
    return min + this.next() * (max - min);
  }

  int(min, maxInclusive) {
    return Math.floor(this.range(min, maxInclusive + 1));
  }
}

export const globalRandom = new Random(0x00ff41);
